import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  const primary = theme.palette.primary.main
  const secondary = theme.palette.secondary.main

  return {
    button: {
      fontWeight: 300,
      fontSize: '100%',
      lineHeight: 'normal',
      textAlign: 'center',
      color: '#000000',
      padding: '0.6em 2.36em',
      borderRadius: 4,
      textTransform: 'inherit',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    primaryOutlined: {
      border: `1px solid ${primary}`,
      '&:hover': {
        boxShadow: `0 0 0 1px ${primary}`,
      },
      '&:active': {
        boxShadow: `0 0 0 1px ${primary}`,
      },
    },
    secondaryOutlined: {
      border: `1px solid ${secondary}`,
      '&:hover': {
        boxShadow: `0 0 0 1px ${secondary}`,
      },
      '&:active': {
        boxShadow: `0 0 0 1px ${secondary}`,
      },
    },
    buttonContained: {
      fontSize: 16,
      padding: '12px 0',
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: 1,
      textTransform: 'none',
    },
    buttonLink: {
      fontSize: 12,
      lineHeight: 2.47,
      letterSpacing: 2,
      textAlign: 'center',
    },
    btnEdit: {
      width: 61,
      height: 59,
      border: 0,
      backgroundColor: 'transparent',
      padding: 0,
      outline: 'none',
      cursor: 'pointer',
    },
  }
})
